import { render, staticRenderFns } from "./DoctorsMtBanner.vue?vue&type=template&id=15f8d978&"
import script from "./DoctorsMtBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorsMtBanner.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f8d978')) {
      api.createRecord('15f8d978', component.options)
    } else {
      api.reload('15f8d978', component.options)
    }
    module.hot.accept("./DoctorsMtBanner.vue?vue&type=template&id=15f8d978&", function () {
      api.rerender('15f8d978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorsMtBanner.vue"
export default component.exports